module.exports = __webpack_public_path__ + "img/32.38724143.svg";